import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {MultiColorIcon} from '../../../../../leap/components/icons'

const OpenConfiguratorBtn = (props) => {
    const {formatMessage} = useIntl()
    const openConfiguratorLabel = formatMessage({
        id: 'product_detail.cta.customize',
        defaultMessage: 'Customize & Buy'
    })

    return (
        <Button
            variant="secondaryGhost"
            width="fillContent"
            size="lg"
            aria-label={openConfiguratorLabel}
            {...props}
        >
            <Text>
                <FormattedMessage
                    id="product_detail.cta.customize"
                    defaultMessage="Customize & Buy"
                />
            </Text>
            <MultiColorIcon />
        </Button>
    )
}

export default OpenConfiguratorBtn
